import {
  EventsResponse,
  UnifiedEvent,
  Holiday,
  WorldDay,
  CityEvent,
  LocalEvent,
  CustomEvent,
} from '../types';

function getEventDate(e: any): string {
  return e.date || e.start_date || '';
}

function getEndDate(e: any): string | null {
  return e.end_date || null;
}

function toUnified(e: Holiday): UnifiedEvent;
function toUnified(e: WorldDay): UnifiedEvent;
function toUnified(e: CityEvent): UnifiedEvent;
function toUnified(e: LocalEvent): UnifiedEvent;
function toUnified(e: CustomEvent): UnifiedEvent;
function toUnified(e: any): UnifiedEvent {
  const date = getEventDate(e);
  const endDate = getEndDate(e);
  const isHoliday = e.type === 'public_holiday';

  let detail = '';
  let location: string | undefined;
  let keywords: string[] | undefined;
  let visitors: number | undefined;

  switch (e.type) {
    case 'public_holiday':
      detail = e.is_national ? 'Bundesweit' : 'Regional';
      break;
    case 'world_day':
      detail = e.gastro_relevance === 'high' ? 'Gastro-Highlight' : e.name_en || '';
      keywords = e.keywords;
      break;
    case 'city_event':
      detail = e.description || '';
      location = e.city;
      keywords = e.keywords;
      visitors = e.expected_visitors;
      break;
    case 'local_event':
      detail = [e.venue_name, e.venue_city].filter(Boolean).join(', ');
      location = e.venue_city;
      break;
    case 'custom_event':
      detail = e.description || '';
      keywords = e.keywords;
      visitors = e.expected_visitors;
      break;
  }

  return { date, endDate, name: e.name, type: e.type, isHoliday, detail, keywords, visitors, location, raw: e };
}

export function unifyEvents(data: EventsResponse): UnifiedEvent[] {
  const all: UnifiedEvent[] = [
    ...data.holidays.map(h => toUnified(h)),
    ...data.world_days.map(w => toUnified(w)),
    ...data.city_events.map(c => toUnified(c)),
    ...data.local_events.map(l => toUnified(l)),
    ...data.custom_events.map(c => toUnified(c)),
  ];
  all.sort((a, b) => a.date.localeCompare(b.date));
  return all;
}

export function groupEventsByDate(events: UnifiedEvent[]): Map<string, UnifiedEvent[]> {
  const map = new Map<string, UnifiedEvent[]>();
  for (const ev of events) {
    const list = map.get(ev.date) || [];
    list.push(ev);
    map.set(ev.date, list);
  }
  return map;
}

export function eventsOnDate(events: UnifiedEvent[], dateStr: string): UnifiedEvent[] {
  return events.filter(ev => {
    if (ev.date === dateStr) return true;
    if (ev.endDate && ev.date <= dateStr && ev.endDate >= dateStr) return true;
    return false;
  });
}
